import { IconPropsType } from '..';

export const ArrowDownIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.39964 12.4155L5.17482 8.19066C5.11655 8.13239 5.07284 8.06926 5.0437 8.00127C5.01457 7.93328 5 7.86044 5 7.78275C5 7.62735 5.05342 7.49138 5.16025 7.37483C5.26709 7.25829 5.40791 7.20001 5.58273 7.20001H14.4403C14.6151 7.20001 14.7559 7.25829 14.8628 7.37483C14.9696 7.49138 15.023 7.62735 15.023 7.78275C15.023 7.82159 14.9647 7.95757 14.8482 8.19066L10.6234 12.4155C10.5263 12.5126 10.4291 12.5806 10.332 12.6194C10.2349 12.6583 10.1281 12.6777 10.0115 12.6777C9.89496 12.6777 9.78813 12.6583 9.691 12.6194C9.59388 12.5806 9.49676 12.5126 9.39964 12.4155Z" />
  </svg>
);
